import React from 'react'
import PropTypes from 'prop-types'
import { defaultT } from '../../utils/i18n'

const FormField = ({ required, label, children, t = defaultT, fullWidth, hideLabel, width, type, widthClassName }) => {
    const fieldWidth = width && {width}

    const customClassName = widthClassName || "col-xs-12 col-sm-12 col-md-12 col-lg-12"

    return (
        <div className={customClassName} style={{marginBottom: '25px'}}>
            { !['readOnly', 'readOnlyObject', 'text', 'textarea', 'number', 'dropdownObject', 'tags', 'tagsWithCustomOptions', 'comment2', 'files2', 'checkbox', 'datePicker', 'dateRange', 'dtObjects' ,'accordion', 'richTextEditor', 'image', 'video', 'creatableTags','monthPicker', 'yearPicker', 'timePicker', 'monthPickerRange', 'password', 'dualBoxList', 'dualTableList', 'phoneNumber', 'toggle', 'booleanToggle', 'colorPicker', 'logoPicker', 'conversation'].includes(type) && !fullWidth && <label style={{fontWeight: 400, fontSize: '14px', marginBottom: '5px'}}>{!hideLabel && t(label, { capitalize: true })} {!hideLabel && required && '*'}</label> }
            <div style={fieldWidth}>
                {children}
            </div>
        </div>
    )
}

FormField.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    t: PropTypes.func
}

export default FormField
